module.exports = __webpack_public_path__ + "img/cloud-dns.ebe244b.svg";